<kendo-dialog *ngIf="opened" title="Upload Files" (close)="close()" [minWidth]="250" [width]="600">

  <div class="form-group">
    <label class="form-label">Files</label>
    <div class=" col-12">
      <kendo-upload #myUpload="kendoUpload" [autoUpload]="false" [saveUrl]="uploadSaveUrl" (cancel)="cancel($event)"
        (clear)="clear()" (complete)="complete()" (error)="error($event)" (blur)="blur()" (focus)="focus()"
        (pause)="pause($event)" (resume)="resume($event)" (select)="select($event)" (success)="success($event)"
        (upload)="upload($event)" (uploadProgress)="uploadProgress($event)" (valueChange)="valueChange($event)"
        [restrictions]="fileRestrictions" [(ngModel)]="myFiles">
        <!-- <ng-template kendoUploadFileInfoTemplate let-files let-state="state">
          <div>Name: {{ files[0].name }} Size: {{ files[0].size }} bytes</div>
          @if (showButton(state)) {
          <button kendoButton (click)="remove(myUpload, files[0].uid)"
            style="position: absolute; right: .2em; bottom: 0.8em;">
            Remove
          </button>
          }
          <span *ngIf="state === 'invalid' && files.validationErrors" class="validation-error-message">
            {{files.validationErrors[0].message}}
          </span>
        </ng-template> -->
        <kendo-upload-messages select="Select files"> </kendo-upload-messages>
        <kendo-upload-messages dropFilesHere="or drop files here to add (max size 100 MB)"></kendo-upload-messages>
      </kendo-upload>
      <div class="demo-hint" style="color: #231f20 !important">You can upload any files.</div>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="close()">Cancel</button>
    <button kendoButton [disabled]="!myFiles || myFiles.length === 0" (click)="insert()" themeColor="primary">Insert</button>
    <!-- <button kendoButton (click)="insert()" themeColor="primary">Insert</button> -->
    <!-- <p>myFiles: {{myFiles | json}}</p> -->
  </kendo-dialog-actions>
</kendo-dialog>
